import { SendOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, message } from 'antd';
import qs from 'qs';
import React from 'react';
import { useDispatch } from 'react-redux';

import { updateReportCount } from '../../actions/AsyncTaskReportAction';
import { fetchAPI } from '../../utils/api';

const reportKeyMap = {
  WEEKLY_REPORT_DHL_EMAILS: {
    key: 'WEEKLY_REPORT_DHL_EMAILS',
    label: 'Send report to DHL',
    entity: 'DHL',
  },
  WEEKLY_REPORT_INTERNAL_EMAILS: {
    key: 'WEEKLY_REPORT_INTERNAL_EMAILS',
    label: 'Send DHL report internally',
    entity: 'DHL',
  },
  WEEKLY_REPORT_DHL_EMAILS_WITH_FILTERS: {
    key: 'WEEKLY_REPORT_INTERNAL_EMAILS',
    label: 'Send DHL report internally with filters',
    entity: 'DHL',
  },
  WEEKLY_REPORT_DHL_EMAILS_WITHOUT_FILTERS: {
    key: 'WEEKLY_REPORT_INTERNAL_EMAILS',
    label: 'Send DHL report internally without filters',
    entity: 'DHL',
  },
  WEEKLY_REPORT_CW_EMAILS: {
    key: 'WEEKLY_REPORT_CW_EMAILS',
    label: 'Send report to CW',
    entity: 'CW',
  },
  WEEKLY_REPORT_CW_INTERNAL_EMAILS: {
    key: 'WEEKLY_REPORT_CW_INTERNAL_EMAILS',
    label: 'Send CW report internally',
    entity: 'CW',
  },
};

const OrderSendReportMenu = () => {
  const dispatch = useDispatch();

  const generateWeeklyReport = async payload => {
    // setWeeklyReport(true);
    try {
      const resp = await fetchAPI('reports/send-weekly-report', {
        method: 'POST',
        payload,
      });
      let msg = 'Weekly report has been sent to the emails';
      if (!!resp.is_async_active) {
        msg =
          'We are processing you report. Please open menu report to check the status!';
        const { counter } = await fetchAPI('reports/async-task-report/counter');
        dispatch(updateReportCount(counter));
      }
      message.success(msg);
    } catch (error) {
      message.error('Failed to request reports!', 3);
      if (error.message) {
        message.error(error.message);
      }
    }
    // setWeeklyReport(false);
  };

  return (
    <Dropdown
      trigger={['click']}
      overlay={
        <Menu
          onClick={e => {
            const filters = qs.parse(window.location.search, {
              ignoreQueryPrefix: true,
            });
            generateWeeklyReport({
              constant_id: reportKeyMap[e.key].key,
              entity: reportKeyMap[e.key].entity,
              label: reportKeyMap[e.key].label,
              filters:
                e.key === 'WEEKLY_REPORT_DHL_EMAILS_WITH_FILTERS'
                  ? filters
                  : undefined,
              wo_filters:
                e.key === 'WEEKLY_REPORT_DHL_EMAILS_WITHOUT_FILTERS'
                  ? true
                  : undefined,
            });
          }}
        >
          {Object.keys(reportKeyMap).map(key => (
            <Menu.Item key={key}>{reportKeyMap[key].label}</Menu.Item>
          ))}
        </Menu>
      }
    >
      <Button icon={<SendOutlined />}>Send report</Button>
    </Dropdown>
  );
};

export default OrderSendReportMenu;
